import { useState, useEffect, useCallback } from 'react';
import BannerService from '../components/user/common/services/BannerService'

export const useBanners = (location, section, userType = 'all', options = {}) => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const { 
        autoTrackImpressions = true, 
        refreshInterval = null,
        onBannerClick = null 
    } = options;

    const fetchBanners = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            
            let response;
            if (section) {
                response = await BannerService.getBannersByLocationAndSection(location, section, userType);
            } else {
                response = await BannerService.getBannersByLocation(location, userType);
            }
            
            if (response.status) {
                setBanners(response.data);
                
                // Auto-track impressions
                if (autoTrackImpressions && response.data.length > 0) {
                    response.data.forEach(banner => {
                        BannerService.trackImpression(banner._id);
                    });
                }
            }
        } catch (err) {
            setError(err.message);
            console.error('Error fetching banners:', err);
        } finally {
            setLoading(false);
        }
    }, [location, section, userType, autoTrackImpressions]);

    useEffect(() => {
        fetchBanners();
    }, [fetchBanners]);

    // Set up refresh interval if specified
    useEffect(() => {
        if (refreshInterval) {
            const interval = setInterval(fetchBanners, refreshInterval);
            return () => clearInterval(interval);
        }
    }, [fetchBanners, refreshInterval]);

    const handleBannerClick = useCallback(async (banner) => {
        // Track click
        await BannerService.trackClick(banner._id);
        
        // Custom click handler
        if (onBannerClick) {
            onBannerClick(banner);
        } else if (banner.ctaLink) {
            window.open(banner.ctaLink, '_blank', 'noopener,noreferrer');
        }
    }, [onBannerClick]);

    const refreshBanners = useCallback(() => {
        fetchBanners();
    }, [fetchBanners]);

    return {
        banners,
        loading,
        error,
        handleBannerClick,
        refreshBanners
    };
};